__turbopack_context__.v({
  "wrapper": "ImageElement-module__67tzJG__wrapper",
});
